<template>
    <h2 class="heading"><slot /></h2>
</template>

<script>
export default {
}
</script>
